export const SimpleTable = (props) => {

    const {
        headers,
        rows,
        onClick,
        onChange,
        name,
        className
    } = props;

    return (
        <div className={className || "m-2"}>
            {name &&
                <div className="flex justify-between mt-3">
                    <h5 className="text-app-primary text-2xl">{name}</h5>
                </div>
            }
            <table className="min-w-full text-left text-sm font-light text-surface dark:text-white">
                <thead className="border-b border-neutral-200 font-medium dark:border-white/10">
                    <tr>
                        {headers.map((element) => {
                            return (
                                <th
                                    scope="col"
                                    key={"col_" + element[0]}
                                    className="px-6 py-2"
                                >
                                    {element}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((elements, lineNumber) => {
                        return (
                            <tr
                                onClick={() => onClick(lineNumber)}
                                key={elements[0]}
                                className="border-b border-neutral-200 dark:border-white/10 cursor-pointer hover:bg-app-secondary"
                            >
                                <td className="whitespace-nowrap px-6 py-2 w-auto">
                                    {typeof elements[1] !== "undefined" ? elements[1] : "Non renseigné"}
                                </td>
                                <td className="whitespace-nowrap px-6 py-2 w-auto">

                                    <div className="relative">
                                        <select
                                            className="block min-w-48 appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded-sm leading-tight focus:outline-hidden focus:bg-white focus:border-gray-500"
                                            id="grid-state"
                                            defaultValue={elements[3]}
                                            value={elements[3]}
                                            onChange={(e) => onChange([elements[0], e.target.value])}
                                        >
                                            {elements[2].map((option) => {
                                                return <option value={option[0]}>{option[1]}</option>;
                                            })}
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg
                                                className="fill-current h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                            </svg>
                                        </div>
                                    </div>

                                </td>
                            </tr>
                        );
                    })}
                    {rows.length === 0 && (
                        <tr className="border-b border-neutral-200 dark:border-white/10 cursor-pointer hover:bg-app-secondary">
                            <td
                                colSpan={headers.length}
                                className="text-center"
                            >
                                Aucun élément n'est présent.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
